const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-multi-label-start-end',
        label: '작성일', // 디폴트 값
        value: 'date',
        query: { 'lb': 'label', 'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: { lb: '', sd: '', ed: '' },
          labels: ['작성일', '계획일'],
          gridTemplateColumns: '114px auto',
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['계획일', '작성일']}
      },
      {'component': 'empty-space'},
      {
        'component': 'search-company-ids',
        label: '관련부서',
        value: 'companies',
        options: {
          gridTemplateColumns: '114px 1fr',
        }
      },
      {'component': 'empty-space'},
      {
        'component': 'search-year', label: '연도', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear(),
          gridTemplateColumns: '114px auto',
        }
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let dateTarget = "created_at";
    let dateBegin = `${new Date().getFullYear()}-01-01`;
    let dateEnd = `${new Date().getFullYear()}-12-31`;
    if (search.year) {
      dateBegin = `${search.year}-01-01`;
      dateEnd = `${search.year}-12-31`;
    }

    //  검색일
    if (search.date) {
      if (search.date.startDate) dateBegin = search.date.startDate;
      if (search.date.endDate) dateEnd = search.date.endDate;

      // 검색일 타겟
      if (search.date.label) {
        if (search.date.label === '계획일') dateTarget = "body.stdInfo.계획일";
        else if (search.date.label === '작성일') dateTarget = "created_at";
      }
    }
    conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
    conditions.push({key: dateTarget, operator: '<', value: new Date(dateEnd).addDays(1).format("yyyy-MM-dd")})

    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "시설물명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "소속명",
        "key": "body.stdInfo.department"
      },
      {
        "name": "부서명",
        "key": "body.stdInfo.section"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      },
      {
        "name": "계획일",
        "key": "body.stdInfo.계획일"
      },
      {
        "name": "작성일",
        "key": "created_at"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name; // 시설물명
      case 1:
        return func.getContent(value).stdInfo.department; // 소속명
      case 2:
        return func.getContent(value).stdInfo.section; // 부서명
      case 3:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      case 4: return func.getContent(value).stdInfo.계획일 // 계획일
      case 5: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
